var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { Button, Heading, Text, AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter, } from 'shared/components';
export var OutOfSyncAlert = function (_a) {
    var disclosure = _a.disclosure;
    var cancelRef = useRef(null);
    return (_jsx(AlertDialog, __assign({ size: "2xl", isOpen: disclosure.isOpen, leastDestructiveRef: cancelRef || null, onClose: disclosure.onClose, closeOnOverlayClick: false, closeOnEsc: false }, { children: _jsx(AlertDialogOverlay, { children: _jsxs(AlertDialogContent, { children: [_jsx(AlertDialogHeader, __assign({ px: 5 }, { children: _jsx(Heading, __assign({ size: "h2" }, { children: "Note Draft Discrepancy" })) })), _jsx(AlertDialogBody, __assign({ px: 5 }, { children: _jsx(Text, __assign({ size: "body2", pb: 2 }, { children: "This note has been updated in another tab. You will need to refresh this page to see the latest draft of the note." })) })), _jsx(AlertDialogFooter, __assign({ paddingInline: 5 }, { children: _jsx(Button, __assign({ variant: "primary", ref: cancelRef, onClick: function () {
                                window.location.reload();
                            }, flexBasis: 1, flexGrow: 1 }, { children: "Refresh page" })) }))] }) }) })));
};
